import { useSelector } from 'react-redux';
import { TState } from '../../redux/store';
import ManageEntries from '../table/actions/ManageEntries';
import ManageTabs from '../table/actions/ManageTabs';
import ManageUsers from '../table/actions/ManageUsers';
import ManageFilters from '../table/actions/ManageFilters';
import ManageRoles from '../table/actions/ManageRoles';
import ManageInputs from '../table/actions/ManageInputs';
import ManageActions from '../table/actions/ManageActions';
import ManagePlanning from '../table/actions/ManagePlanning';
import ManageImport from '../table/actions/ManageImport';
import ManageDocuments from '../table/actions/ManageDocuments';
import ManageCustom from '../table/actions/ManageCustom';
import ManageDuplicate from '../table/actions/ManageDuplicate';
import ManageMajs from '../table/actions/ManageMajs';
import ManageQuickActions from '../table/actions/ManageQuickActions';
import ManagePdfMatching from '../table/actions/ManagePdfMatching';
import ManageStats from '../table/actions/ManageStats';

const ModalTable = () => {
  const modalType = useSelector((state: TState) => state.modalType);

  switch (true) {
    case /entry$/i.test(modalType):
      return <ManageEntries />;
    case /tab$/i.test(modalType):
      return <ManageTabs />;
    case /user$/i.test(modalType):
      return <ManageUsers />;
    case /filters$/i.test(modalType):
      return <ManageFilters />;
    case /role$/i.test(modalType):
      return <ManageRoles />;
    case /input$/i.test(modalType):
      return <ManageInputs />;
    case /action$/i.test(modalType):
      return <ManageActions />;
    case /actions$/i.test(modalType):
      return <ManageQuickActions />;
    case /planning$/i.test(modalType):
      return <ManagePlanning />;
    case /import$/i.test(modalType):
      return <ManageImport />;
    case /document$/i.test(modalType):
      return <ManageDocuments />;
    case /custom$/i.test(modalType):
      return <ManageCustom />;
    case /duplicate$/i.test(modalType):
      return <ManageDuplicate />;
    case /displayMajs$/i.test(modalType):
      return <ManageMajs />;
    case /pdfMatching$/i.test(modalType):
      return <ManagePdfMatching />;
    case /stats$/i.test(modalType):
      return <ManageStats />;
    default:
      return null;
  }
};

export default ModalTable;
